// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalUserCertificationsModuleLayout} from 'app_components/modules/modalUserCertifications'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { IUserCertification } from 'app_types/campus/user/userInfoTypes'
// @end

// @ADD Component types
interface IModalUserCertificationsModuleProps {
  open       : boolean
  handleClose: (data:any) => void
  certifications: IUserCertification[]
}
interface IModalUserCertificationsModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalUserCertificationsModule extends Component<IModalUserCertificationsModuleProps, IModalUserCertificationsModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalUserCertificationsModuleProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ModalUserCertificationsModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        certifications={this.props.certifications}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalUserCertificationsModule)
